function initGeoIp() {
    if (!document.querySelector('.js-bxmaker__geoip__city__line-question')) return;

    const geoPopup = document.querySelector('.js-bxmaker__geoip__city__line-question');
    const geoPopupParent = geoPopup.parentElement;
    const header = document.querySelector('.site-header');

    function setPosition() {
        if (window.innerWidth <= 1023) {
            header.append(geoPopup);
        } else {
            geoPopupParent.append(geoPopup);
        }
    }

    setPosition();
    window.addEventListener('resize', setPosition);
}
